/**
 * Tooltipを表示するコンポーネント。
 * 実体DOM生成時に初期化が必要な為コンポーネント化
 * https://getbootstrap.com/docs/5.2/components/tooltips/
 */
export default {
    // see resources/views/components/_vue_tooltip.blade.php
    template: '#tooltip_template',
    props: {
        // tooltip位置
        position: {
            type: String,
            default: 'top',
            require: false,
        },
        // tooltip文言
        title: {
            type: String,
            require: true,
        }
    },
    mounted: function() {
        // Tooltip初期化
        $(this.$refs.tooltip).tooltip({placement: this.position});
    },
    methods: {
        hide: function () {
            $(this.$refs.tooltip).tooltip('hide');
        }
    }
};
